<div
  class="company-detail"
  [formGroup]="form"
  data-qa="company-details"
>
  <div class="row" data-qa="company-title-row">
    <div class="col-12" data-qa="company-title-col">
      <span class="registration-title" data-qa="page-title">Company Details</span>
    </div>
  </div>
  <div class="row" data-qa="company-subtitle-row">
    <div class="col-12" data-qa="company-subtitle">
      <div class="registration-sub-title" data-qa="company-subtitle-text">
        Enter your company details to create a profile.
      </div>
    </div>
  </div>
  <div class="row" data-qa="country-label-row">
    <div class="col-12" data-qa="country-label">
      <label class="registration-label" data-qa="country-label-text">Country *</label>
    </div>
  </div>
  <div class="row" data-qa="country-input-row">
    <div class="col-12" data-qa="country-input">
      <div class="p-field" data-qa="country-field">
        <p-dropdown
          [options]="countries"
          optionLabel="name"
          optionValue="code"
          [style]="{ width: '100%' }"
          formControlName="country"
        />
      </div>
    </div>
  </div>
  @if (isInternationalCompany()) {
    <div class="row row-international-company" data-qa="international-warning">
      <div class="international-manufacturer" data-qa="international-checkbox">
        <p-checkbox
          id="internationalManufacturer"
          name="internationalManufacturer"
          [binary]="true"
          (onChange)="acknowledgmentChange()"
        >
        </p-checkbox>

        <div class="label-international" data-qa="international-label">
          <label for="internationalManufacturer" data-qa="international-disclaimer"
            >I'm a manufacturer who doesn't operate in the United States. I
            understand the
            <a
              href="https://www.sustainment.com/community-guidelines"
              target="_blank"
              ><b><u>restrictions</u></b></a
            >
            that apply to my account.
          </label>
        </div>
      </div>
    </div>
  }
  <div class="row" data-qa="name-label-row">
    <div class="col-12" data-qa="name-label">
      <label class="registration-label" data-qa="name-label-text">Company Name *</label>
    </div>
  </div>
  <div class="row" data-qa="name-input-row">
    <div class="col-12" data-qa="name-input">
      <div class="p-field" data-qa="company-name-field">
        <input
          id="name"
          type="text"
          pInputText
          placeholder="Enter company name"
          formControlName="name"
          maxlength="300"
          asciiOnly
        />
      </div>
    </div>
  </div>
  <div class="row" data-qa="address-label-row">
    <div class="col-12" data-qa="address-label">
      <label class="registration-label" data-qa="address-label-text">Street Address *</label>
    </div>
  </div>
  <div class="row" data-qa="address-input-row">
    <div class="col-12" data-qa="address-input">
      <div class="p-field" data-qa="address-field">
        <s-location
          [searchResults]="(searchResults$ | async) || []"
          (searchLocation)="searchLocation($event)"
          placeholder="Enter your primary facility address"
          [isRequired]="true"
          [showRequiredMessage]="false"
          [location]="form.value.address"
          (locationChange)="onLocationChanged($event)"
        />
      </div>
    </div>
  </div>
  <div class="row" data-qa="address2-label-row">
    <div class="col-12" data-qa="address2-label">
      <label class="registration-label" data-qa="address2-label-text">Apt, ste, bldg.</label>
    </div>
  </div>
  <div class="row" data-qa="address2-input-row">
    <div class="col-12" data-qa="address2-input">
      <div class="p-field" data-qa="address2-field">
        <input
          type="text"
          pInputText
          placeholder="Apt, ste, bldg."
          maxlength="200"
          formControlName="address2"
        />
      </div>
    </div>
  </div>
  <div [style]="{ display: 'flex', width: '100%' }" data-qa="city-state-zip-row">
    <div
      class="p-field"
      [style]="{ width: '100%' }"
      data-qa="city-field"
    >
      <label class="registration-label" data-qa="city-label-text">City *</label>
      <input
        id="website"
        type="text"
        pInputText
        placeholder="Enter city"
        formControlName="city"
        maxlength="75"
      />
    </div>
    <div
      class="p-field"
      [style]="{ width: '100%' }"
      data-qa="state-field"
    >
      <div
        [style]="{ display: 'flex', flexDirection: 'column', width: '100%' }"
        data-qa="state-container"
      >
        <label class="registration-label" data-qa="state-label-text">State</label>
        <p-dropdown
          [style]="{ width: '100%' }"
          [options]="stateAbbreviations()"
          formControlName="state"
        />
      </div>
    </div>
    <div
      class="p-field"
      [style]="{ width: '100%' }"
      data-qa="zip-field"
    >
      <label class="registration-label" data-qa="zip-label-text">Zip code</label>
      <input
        id="website"
        type="text"
        pInputText
        placeholder="Enter zip code"
        formControlName="zip"
        maxlength="75"
      />
    </div>
  </div>
  <div class="row" data-qa="website-label-row">
    <div class="col-12" data-qa="website-label">
      <label class="registration-label" data-qa="website-label-text">Website</label>
    </div>
  </div>
  <div class="row" data-qa="website-input-row">
    <div class="col-12" data-qa="website-input">
      <div class="p-field" data-qa="website-field">
        <input
          id="website"
          type="text"
          pInputText
          placeholder="Enter the company website"
          formControlName="website"
          maxlength="75"
        />
      </div>
    </div>
  </div>
  <div class="row registration-comments" data-qa="required-fields-note">
    <div class="col-12" data-qa="required-fields-text">
      <span data-qa="required-indicator">* indicates required field</span>
    </div>
  </div>
</div>
